
import compSubmit from './operates/submit'
import compLogistics from './operates/logistics'
import { HttpShipBillList, HttpUpdateShipBillStatus, HttpDeleteShipBill, HttpPushShipBill, HttpShipOBillPackingUrl, HttpTransferShipBill, HttpCopyShipBill } from '@/service/boss/shipment'
import TableList from "@components/templates/tablelist";
import { mapState, mapGetters } from 'vuex';
import comIndex from './update/index'

export default {
    mixins: [TableList],
    components: {
        compSubmit,
        compLogistics,
        comIndex,
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                search: {
                    EQ_errorStatus: null,
                    ...this.$route.query
                }
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
            isSuper: this.$store.state.userinfo.isSuper
        };
    },
    methods: {
        ajaxRequest: HttpShipBillList,
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning('请选择至少一条数据');
            }
            switch (type) {
                case 'query':
                    this.operate = {
                        show:true,
                        width:1200,
                        component: "comIndex",
                        activeids: params,
                        querytype:'query',
                        title:'查看',
                        showFooter: false,
                    }
                    break;
                case 'queryBlank':
                        const url = this.$router.resolve({
                            name: 'spBillupdate',
                            params: { type: 'query' },
                            query: { id: params },
                        });
                        window.open(url.href, '_blank');
                        break;
                case 'queryEdit':
                    this.$router.push({
                        name: 'spBillupdate',
                        params: { type: 'query' },
                        query: { id: params, issuper: this.isSuper }
                    });
                    break;
                case 'bill':
                case 'edit':
                    this.$router.push({
                        name: 'spBillupdate',
                        params: { type },
                        query: { id: params }
                    });
                    break;
                case 'add':
                    this.$router.push({
                        name: 'spBillupdate',
                        params: { type }
                    });
                    break;
                case 'cancel':
                    this.operate = {
                        show: true,
                        alert: "error",
                        title: "取消操作",
                        width: 460,
                        cancelText: '暂不取消',
                        confirmText: '确定取消',
                        showDesc: false,
                        params,
                        ajaxRequest: HttpUpdateShipBillStatus,
                        formdata: [
                            {
                                tag: "vTextarea",
                                key: "remark",
                                span: 24,
                                label: "备注"
                            }
                        ]
                    };
                    break;
                case 'delete':
                    this.operate = {
                        show: true,
                        alert: "error",
                        title: "删除操作",
                        params: {
                            id: params
                        },
                        ajaxRequest: HttpDeleteShipBill
                    }
                    break;
                case 'push':
                    this.operate = {
                        show: true,
                        alert: "primary",
                        title: "推送仓储操作",
                        params: {
                            ids: params
                        },
                        ajaxRequest: HttpPushShipBill
                    }
                    break;
                case 'transfer':
                    this.operate = {
                        show: true,
                        alert: "primary",
                        title: "批量推送中转",
                        params: {
                            ids: params
                        },
                        ajaxRequest: HttpTransferShipBill
                    }
                    break;
                case 'submit':
                    this.operate = {
                        show: true,
                        alert: "primary",
                        title: "更改单据状态",
                        showFooter: false,
                        ...params,
                        component: 'compSubmit'
                    }
                    break;
                case 'logistics':
                    this.operate = {
                        title: '单据物流',
                        show: true,
                        width: 1000,
                        component: "compLogistics",
                        shipmentNo: params,
                    };
                    break;
                case 'packurl':
                    this.getPackUrl(params)
                    break;
                case 'copy':
                    this.operate = {
                        show: true,
                        alert: "primary",
                        title: "发运单单据复制",
                        desc: `确定复制发运单单据？`,
                        params: {
                            id: params
                        },
                        ajaxRequest: HttpCopyShipBill,
                        callback(res) {
                            this.$VMessage.success({
                                content: `复制成功，新单号为${res.data}`,
                                duration: 60,
                                closable: true
                            });
                        }
                    }
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id, orderStatus, shipType, shipmentNo } = row;
            return [{
                label: '查看',
                show: true,
                params: id,
                operate: 'query'
            }, {
                label: '编辑',
                show: orderStatus !== 'close' && orderStatus !== 'submit' && orderStatus !== 'confirm' && orderStatus !== 'shipment' && orderStatus !== 'complete',
                params: id,
                operate: 'edit'
            }, {
                label: '编辑',
                show: orderStatus === 'shipment',
                params: id,
                operate: 'queryEdit'
            }, {
                label: '复制',
                show: orderStatus !== 'draft',
                params: id,
                operate: 'copy'
            }, {
                label: '提交',
                show: orderStatus !== 'close' && orderStatus !== 'submit' && orderStatus !== 'confirm' && orderStatus !== 'shipment' && orderStatus !== 'complete',
                params: { status: 1, shipType, id },
                operate: 'submit'
            }, {
                label: '取消',
                show: orderStatus !== 'close' && orderStatus !== 'shipment' && orderStatus !== 'complete',
                params: { status: 6, id },
                operate: 'cancel'
            }, {
                label: '添加子单据',
                show: orderStatus !== 'close' && shipType != 0 && orderStatus !== 'submit' && orderStatus !== 'confirm' && orderStatus !== 'shipment' && orderStatus !== 'complete',
                params: id,
                operate: 'bill'
            }, {
                label: '查看物流历史',
                show: true,
                params: shipmentNo,
                operate: 'logistics'
            }, {
                label: '导出箱标',
                show: true,
                params: id,
                operate: 'packurl'
            }, {
                label: '删除',
                show: orderStatus !== 'close' && orderStatus !== 'submit' && orderStatus !== 'confirm' && orderStatus !== 'shipment' && orderStatus !== 'complete',
                params: id,
                operate: 'delete'
            }]
        },
        async getPackUrl(id) {
            this.handleWebfs(HttpShipOBillPackingUrl, {id}, {
                type: 'url',
                executor: 'request',
                download:true,
                interceptResponse:(res)=>res.data,
            })
        },
    },
    computed: {
        ...mapGetters('boss', ['otherWarehouses', 'warehouses']),
        ...mapGetters('diction',['getNewProductList']),

        TabsData() {
            return [
                {
                    name: "所有",
                    key: 'EQ_errorStatus',
                    val: null
                }, {
                    name: "异常",
                    key: 'EQ_errorStatus',
                    val: "abnormal"
                }, {
                    name: "正常",
                    key: 'EQ_errorStatus',
                    val: "normal"
                },
            ]
        },
        ToolsData() {
            return [
                {
                    name: "添加",
                    operate: "add",
                    theme: "primary",
                },
                {
                    name: "推送仓储",
                    operate: "push",
                    theme: "success",
                    batch: true,
                },
                {
                    name: "推送中转",
                    operate: "transfer",
                    theme: "info",
                    batch: true,
                },
            ]
        },
        SearchsData() {
            const otherWarehouses = this.otherWarehouses.map((item) => {
                    const { id, code, title } = item;
                    return {
                        value: id,
                        label: `${code}(${title})`
                    }
                }),
                warehouses = this.warehouses.map((item) => {
                    const { id, code, title } = item;
                    return {
                        value: id,
                        label: `${code}(${title})`
                    }
                });
            return [
                {
                    label: "发运单号",
                    tag: 'vInput',
                    key: 'CN_shipmentNo',
                    show: true,
                    formItem: {
                        title: "输入发运单号，可查询出发运单号或来源单号和输入值相匹配的单据"
                    }
                },
                {
                    label: "ERPSKU",
                    tag: 'vInput',
                    key: 'CN_shipmentPlanOrderItems.erpSku',
                    show: true,
                },
                {
                    label: "项目",
                    tag: 'vSelect',
                    key: 'EQ_lineId',
                    show: true,
                    options: this.getNewProductList,
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: "单据状态",
                    tag: 'vSelect',
                    key: 'IN_orderStatus',
                    style: "width:362px",
                    formatter(value) {
                        return (value || []).join(',')
                    },
                    options: [{
                        value: 'establish',
                        label: '已创建'
                    }, {
                        value: 'submit',
                        label: '已提交'
                    }, {
                        value: 'confirm',
                        label: '已确认'
                    }, {
                        value: 'reject',
                        label: '已驳回'
                    }, {
                        value: 'shipment',
                        label: '已发运'
                    }, {
                        value: 'complete',
                        label: '已完成'
                    }, {
                        value: 'close',
                        label: '已取消'
                    }, {
                        value: 'draft',
                        label: '草稿'
                    }],
                    props: {
                        filterable: true,
                        multiple: true,
                    }
                },
                {
                    label: "采购单号",
                    tag: 'vInput',
                    key: 'CN_shipmentPlanOrderItems.sourceOrderNo',
                },
                {
                    label: "关联单号",
                    tag: 'vInput',
                    key: 'CN_relationBillNos',
                },
                {
                    label: "目的仓",
                    tag: 'vSelect',
                    key: 'EQ_shipmentPlanOrders.orgWarehouseId',
                    options: otherWarehouses
                },
                {
                    label: "中转仓",
                    tag: 'vSelect',
                    key: 'EQ_orgwarehouseId',
                    options: warehouses
                },
                {
                    label: "Shipment ID",
                    tag: 'vInput',
                    key: 'CN_shipmentPlanOrders.shipmentId',
                },
                {
                    label: "运输方式",
                    tag: 'vSelect',
                    key: "EQ_shipmentCode",
                    options: [{
                        value: 'shippingFCL',
                        label: '海运整柜'
                    }, {
                        value: 'shippingLCL',
                        label: '海运散箱'
                    }, {
                        value: 'ownLCL',
                        label: '自散箱'
                    }, {
                        value: 'airlift',
                        label: '空运'
                    }, {
                        value: 'FMS',
                        label: '快递'
                    }, {
                        value: 'shipping',
                        label: '海运'
                    }],
                },
                {
                    label: "预计到货日期",
                    tag: 'vDatepicker',
                    key: 'CN_expectArrivalAts',
                    props: {
                        format: 'yy-mm-dd',
                        confirm: false,
                    },
                },
                {
                    label: "发运类型",
                    tag: 'vSelect',
                    key: 'EQ_shipType',
                    options: [{
                        value: '0',
                        label: '直发'
                    }, {
                        value: '1',
                        label: '中转'
                    }]
                },
                {
                    label: "货代类型",
                    tag: 'vSelect',
                    key: 'EQ_carrierType',
                    options: [{
                        value: 'BIZARK',
                        label: 'BIZARK'
                    }, {
                        value: 'OTHER',
                        label: 'OTHER'
                    }]
                },
                {
                    label: "物流单号",
                    tag: 'vInput',
                    key: 'CN_logisticNos',
                },
                {
                    label: "物流状态",
                    tag: 'vSelect',
                    key: 'EQ_logisticStatus',
                    options: [{
                        value: 'initialization',
                        label: '初始化'
                    }, {
                        value: 'waitWarehouse',
                        label: '待订舱'
                    }, {
                        value: 'bookingWarehouse',
                        label: '已订舱'
                    }, {
                        value: 'customsEntry',
                        label: '已报关'
                    }, {
                        value: 'shipment',
                        label: '已发船'
                    }, {
                        value: 'arrival',
                        label: '已到港'
                    }, {
                        value: 'clearance',
                        label: '已清关'
                    }, {
                        value: 'transferArrival',
                        label: '中转仓到达'
                    }, {
                        value: 'support',
                        label: '已打托'
                    }, {
                        value: 'appointment',
                        label: '已预约'
                    }, {
                        value: 'delivered',
                        label: '已妥投'
                    }, {
                        value: 'inspection',
                        label: '查验中'
                    }]
                },
            ]
        },
        columns() {
            return [{
                type: 'selection',
                width: 40,
                align: 'center',
                formName: 'id'
            }, {
                title: '操作',
                width: 70,
                render: this.getOperateNodes,
            }, {
                title: '单号信息',
                key: 'shipmentNo',
                width:180,
                render: (h, { row }) => {
                    return <div>
                        <div>发运单号:
                            <a onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.shipmentNo}</a>
                            <a onClick={this.handleOperates.bind(this, row.id, 'queryBlank')}><Icon class="margin-left-10 font-14" type="ios-browsers-outline" /></a>
                        </div>
                        关联单号:{row.relationBillNos}
                    </div >;
                }
            }, {
                title: '采购单号',
                key: 'sourceOrderNos',
                render: (h, { row }) => {
                    return row.sourceOrderList.map((item) => {
                        return <div><a target="_blank"
                                       href={`http://boss.onepinnovate.com/index.php/purchase/edit?id=${item.sourceOrderId}`}>{item.sourceOrderNo}</a>
                        </div>
                    })
                }
            }, {
                title: '单据状态',
                key: 'orderStatus',
                width: 80,
                render(h, { row }) {
                    const status = {
                        establish: '已创建',
                        submit: '已提交',
                        confirm: '已确认',
                        reject: '已驳回',
                        shipment: '已发运',
                        complete: '已完成',
                        close: '已取消',
                        // delete: '已删除',
                        draft: '草稿',
                    };
                    return status[row.orderStatus] || ''
                }
            }, {
                title: '项目',
                key: 'lineId',
                render: (h, { row }) => {
                    const id = row.lineId;
                    const { label } = this.getNewProductList.find((item) => {
                        return id == item.value
                    }) || {};
                    return label
                },
            }, {
                title: '发运信息',
                key: 'carrierType',
                render(h, { row }) {
                    const bool = row.shipType == 0;
                    return <div>
                        <div v-show={!bool}>中转仓:{row.transferWarehouseName}</div>
                        <div>货代类型:{row.carrierType}</div>
                        <div>发运类型:{bool ? '直发' : '中转'}</div>
                    </div>
                }
            }, {
                title: '物流信息',
                key: 'logisticStatus',
                render: (h, { row }) => {
                    const data = {
                        initialization: "初始化",
                        waitWarehouse: "待订舱",
                        bookingWarehouse: "已订舱",
                        customsEntry: "已报关",
                        shipment: "已发船",
                        arrival: "已到港",
                        clearance: "已清关",
                        transferArrival: "中转仓到达",
                        support: "已打托",
                        appointment: "已预约",
                        delivered: "已妥投",
                        inspection: "查验中"
                    };
                    // shipmentCodes = {
                    //     shippingFCL: "海运整柜",
                    //     shippingLCL: "海运散箱",
                    //     ownLCL: "自散箱",
                    //     airlift: "空运",
                    //     FMS: "快递",
                    //     shipping: "海运",
                    // };
                    return <div>
                        <div>是否推送物流:{row.pushToLogistic == 1 ? '推送' : '不推送'}</div>
                        <div>物流状态:<a onClick={this.handleOperates.bind(this, row.shipmentNo, 'logistics')}>{data[row.logisticStatus]}</a></div>
                        <div>物流单号:{row.logisticNos}</div>
                    </div>
                }
            }, {
                title: '创建时间',
                key: 'createdAt',
                sortable: true
            }, {
                title: '创建人',
                key: 'createdName',
                width: 80,
                sortable: true
            }];
        },
    },
};




